import app from 'flarum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';

const translationPrefix = 'kilowhat-formulaire.forum.form-create.';

/* global m */

export default class NewFormModal extends Modal {
    className() {
        return 'FormulaireModal FormulaireTheme Modal--small';
    }

    title() {
        return app.translator.trans(translationPrefix + 'title');
    }

    init() {
        super.init();

        this.formTitle = '';
        this.dirty = false;
    }

    content() {
        return m('.Modal-body', [
            m('.Form-group', [
                m('label', app.translator.trans(translationPrefix + 'field.title')),
                m('input.FormControl', {
                    type: 'text',
                    value: this.formTitle,
                    oninput: event => {
                        this.formTitle = event.target.value;
                        this.dirty = true;
                    },
                })
            ]),
            m('.ButtonGroup', [
                Button.component({
                    type: 'submit',
                    className: 'Button Button--primary',
                    loading: this.loading,
                    disabled: !this.dirty,
                    onclick: () => {
                        this.loading = true;

                        app.store.createRecord('formulaire-forms').save({
                            title: this.formTitle,
                            private_title: this.formTitle,
                            link_type: this.props.linkType,
                            // Enable submissions by default on standalone forms since they can't be found easily
                            // We don't do the same for discussion/user fields since those would become immediately visible
                            accept_submissions: this.props.linkType === null,
                        }, {
                            errorHandler: this.onerror.bind(this),
                        }).then(form => {
                            app.modal.close();

                            m.route(app.route.formulaireFormEdit(form));
                        });
                    },
                }, app.translator.trans(translationPrefix + 'button.create')),
            ]),
        ]);
    }
}
